import { render, staticRenderFns } from "./BasicMenu.vue?vue&type=template&id=66c4b31c&"
import script from "./BasicMenu.vue?vue&type=script&lang=js&"
export * from "./BasicMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports